class FormLabel {
  constructor(label) {
    this.label = label

    if (!this.label) return

    this.render()
  }

  render() {
    this.label.classList.add('form-label')
  }
}

export default FormLabel
